import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import LoanApplicationFactory from '../../../domain/newLoanApplication/LoanApplicationFactory';
import Collection from '../../../domain/valueObject/Collection';
import { NewLoanApplicationStepsProps } from '../../../pages/NewLoanApplication';
import { NewLoanSteps } from '../../../utils/enums';
import PartInputField from '../../parts/PartInputField';
import BlockStepsButtons from '../BlockStepsButtons';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface ExistingDebtProps extends NewLoanApplicationStepsProps {}

const ExistingDebt = ({
    nextStep,
    prevStep,
    newLoanEntity
}: ExistingDebtProps) => {
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        resolver: yupResolver(
            yup.object().shape({
                existingDebt: yup
                    .string()
                    .required('Please complete this required field.')
                    .matches(
                        /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                        'You must specify a number.'
                    )
            })
        )
    });

    const onSubmit = (data: any) => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(data)
        );
        nextStep(NewLoanSteps.LOAN_TYPE);
    };

    const handlePrevStep = () => {
        LoanApplicationFactory.makeFromForm(
            newLoanEntity,
            new Collection(getValues())
        );
        prevStep(NewLoanSteps.REHAB_AMOUNT_SPEND);
    };

    useEffect(() => {
        newLoanEntity.hasExistingDebt() &&
            setValue('existingDebt', newLoanEntity.existingDebt.value);
    }, []);

    return (
        <div className="login">
            <div className="container">
                <h1 className="login__title">
                    What is your existing loan amount on the property?
                </h1>
                <p className="login__subtitle login__subtitle--middle">
                    Current Debt Details
                </p>
                <div className="login__box">
                    <PartInputField
                        label="Existing Debt"
                        name="existingDebt"
                        control={control}
                        errors={errors}
                        isRequired
                        isDollarAmount={true}
                    />
                    <BlockStepsButtons
                        prevStep={handlePrevStep}
                        nextStep={handleSubmit(onSubmit)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ExistingDebt;
